class ButtonImpressionLog {
  constructor(windowData, parentPage, selectedVariant) {
    this.productId = windowData.productId;
    this.parentPage = parentPage;
    this.selectedVariant = selectedVariant;
  }

  onUIStarted() {
    this._trackImpression();
  }

  onNewVariant() {
    this._trackImpression();
  }

  _trackImpression() {
    const { skuId, presaleId, releaseId, isSoldOut } =
      this.selectedVariant.getState();

    this.parentPage.postMessage('variant-impression', {
      skuId,
      storeId: this.storeId,
      productId: this.productId,
      presaleId,
      releaseId,
      buttonState: trackingButtonState({ skuId, isSoldOut }),
    });

    function trackingButtonState() {
      if (isSoldOut) {
        return 'SOLD_OUT';
      }
      if (!skuId) {
        return 'SKU_NOT_SELECTED';
      }
      return 'AVAILABLE';
    }
  }
}

export default ButtonImpressionLog;
